import React from 'react'

export default function Terms() {
    return (
        <div>
            <h1>TERMS</h1>
        </div>
    )
}